import { TableColumn } from 'tea-component';
import { uniqBy } from 'lodash-es';
import { formatDateStr, generateMockId } from '@gp/utils/common';
import { CommonColumnBuilders } from '@gp/utils/columns';
import { buildProjectSelectColumn } from '../../../../utils/columns';
import { BoolFlag } from '@gp/enums/common';
import { MilestoneDateStatus } from '@gp/enums/milestone';

import type { IDPSReportContextDTO } from '@gp/types/dpsReport/common';
import type { IDPSReportHightlightVO, IDPSReportHightlightDTO } from '@gp/types/dpsReport/v2';

export const CARD_TITLE = 'Highlights of the Week';

export const buildRecord = (): IDPSReportHightlightVO => ({
  mock_id: generateMockId(),
  project_id: '',
  project: '',
  platform: [],
  image_name: '',
  priority: '',
  cover: '',
  studio: '',
  studio_id: '',
  milestone_id: '',
  milestone: '',
  date_confirm: MilestoneDateStatus.Confirm,
  date: '',
  is_gr: BoolFlag.False,
  is_launch: BoolFlag.False,
});

export const getHightlightRepeatCheckKey = (data?: IDPSReportContextDTO): string => {
  const { project_id: projectId, project, milestone_id: milestoneId, milestone } = data || {};
  return !projectId || !milestoneId ? '' : `${projectId}_${project}_${milestoneId}_${milestone}`;
};

/**
 * 针对即将来临的Hightlights集合，进行去重处理
 * 1、即将来临的Hightlights集合 内部去重，根据getHightlightRepeatCheckKey方法生成的 重复判定标准去重
 * 2、结合当前的Hightlights集合 进行去重，过滤掉当前Hightlights集合中已有的，根据getHightlightRepeatCheckKey方法生成的 重复判定标准去重
 * @param commingList 即将来临的Hightlights集合
 * @param currentList 当前的Hightlights集合
 * @returns 即将来临的Hightlights集合（经过去重处理的）
 */
export const removeDuplicatedHightlights = (
  commingList?: IDPSReportHightlightDTO[],
  currentList?: IDPSReportHightlightDTO[],
): IDPSReportHightlightDTO[] => {
  if (!Array.isArray(commingList) || !Array.isArray(currentList)) return [];
  if (!Array.isArray(commingList)) return currentList;
  if (!Array.isArray(currentList)) return commingList;
  // 当前Hightlights集合的 去重标准映射，value没用，只需要看key是否匹配即可
  const repeatCheckKeys = currentList.reduce<Record<string, true>>((acc, cur) => {
    const repeatCheckKey = getHightlightRepeatCheckKey(cur);
    return { ...acc, [repeatCheckKey]: true };
  }, {});
  return uniqBy(commingList, getHightlightRepeatCheckKey).filter((commingItem) => {
    const commingItemRepeatCheckKey = getHightlightRepeatCheckKey(commingItem);
    return !repeatCheckKeys[commingItemRepeatCheckKey];
  });
};

export const getColumns = (props: { projects?: IGPSelectOptionWithGroup[]; onProjectChange?: (payload: string) => void }) => {
  const { projects, onProjectChange } = props || {};
  return [
    buildProjectSelectColumn({
      options: projects,
      onChange: onProjectChange,
    }),
    CommonColumnBuilders.buildPureTextColumn({
      key: 'date',
      header: 'Date',
      formatter: (cvm) => formatDateStr(cvm?.date, 'YYYY-MM-DD (ddd)'),
    }),
    CommonColumnBuilders.buildPureTextColumn({ key: 'milestone', header: 'Milestone' }),
  ] as TableColumn<IDPSReportHightlightVO>[];
};
